import React from 'react';
import FilterList from '@material-ui/icons/FilterList';
import FilterPres from './FiltersPres';
import Popout from 'src/ui/library/Popout';

const FilterBoxPres = props => {
  const {
    filters,
    selectedMenu,
    applyFilters,
    clearFilters,
    onChange,
    onChangeDate,
    onTextChange,
    handlingDocssubmitted,
    filterIndexes,
    containerRef,
    isCorpClient,
    isApplicant,
    isCase,
    casePhaseList,
    isLoading,
    isLoadingforClick,
    triggerCloseFilters,
    setFiltersDivVisibilityState,
  } = props;

  return (
    <div className="filterbox-icon-wrapper">
      <Popout
        orientation={'left'}
        container={containerRef}
        useContainerWidth={true}
        triggerCloseFilters={triggerCloseFilters}
        setFiltersDivVisibilityState={setFiltersDivVisibilityState}
        trigger={
          <div className="filterbox-trigger">
            <FilterList className="filterbox-icon" />
          </div>
        }
        content={
          <div className="filterBox">
            <FilterPres
              filters={filters}
              selectedMenu={selectedMenu}
              applyFilters={applyFilters}
              onChange={onChange}
              onChangeDate={onChangeDate}
              onTextChange={onTextChange}
              clearFilters={clearFilters}
              filterIndexes={filterIndexes}
              isCorpClient={isCorpClient}
              isApplicant={isApplicant}
              isCase={isCase}
              handlingDocssubmitted={handlingDocssubmitted}
              casePhaseList={casePhaseList}
              isLoading={isLoading}
              isLoadingforClick={isLoadingforClick}
              setFiltersDivVisibilityState={setFiltersDivVisibilityState}
            />
          </div>
        }
      />
    </div>
  );
};

export default FilterBoxPres;



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/FilterBox/FilterBoxPres.js